import { Cancel } from './Cancel';
export function isCanceled(e) {
    return e instanceof Cancel;
}
//# sourceMappingURL=isCanceled.js.map